<template>
  <div class="map_chart mt-5">
    <gmap-map
      :zoom="5.6"
      :center="center"
      style="width: 100%; height: 720px"
      id="map"
    >
      <gmap-marker
        :key="index"
        v-for="(m, index) in locationMarkers"
        :position="m.position"
        :icon="m.icon"
      ></gmap-marker>
    </gmap-map>
  </div>
</template>

<script>
// @ is an alias to /src
import icon1 from "@/assets/icons/icons_general/pin_herb.svg";
import icon2 from "@/assets/icons/icons_general/pin_flower.svg";
import icon3 from "@/assets/icons/icons_general/pin_apple.svg";
import icon4 from "@/assets/icons/icons_general/pin_tree.svg";
import icon5 from "@/assets/icons/icons_general/pin_potato.svg";
import icon6 from "@/assets/icons/icons_general/pin_seed.svg";
import { mapState } from "vuex";

export default {
  name: "map_chart",
  components: {},
  computed: {
    ...mapState({
      map: (state) => {
        return state.dashboardModule.map;
      },
    }),
  },
  data() {
    return {
      center: {
        lat: 13.7066486,
        lng: 101.7860182,
      },
      locationMarkers: [],
      locPlaces: [],
      existingPlace: null,
    };
  },
  mounted() {
    this.$gmapApiPromiseLazy().then(() => {
      this.map.forEach((item) => {
        switch (item.icon) {
          case 1:
            item.icon = icon1;
            break;
          case 2:
            item.icon = icon2;
            break;
          case 3:
            item.icon = icon3;
            break;
          case 4:
            item.icon = icon4;
            break;
          case 5:
            item.icon = icon5;
            break;
          case 6:
            item.icon = icon6;
            break;
        }
        let marker = {
          lat: item.lat,
          lng: item.lng,
        };
        this.locationMarkers.push({
          position: marker,
          icon: { url: item.icon, scaledSize: new google.maps.Size(60, 60) },
        });
      });
    });
  },
};
</script>
<style lang="scss">
.map_chart {
  width: 90%;
  margin: auto;
}
</style>
